/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Container, Row, Col } from "reactstrap";
import hanaLogo from "assets/img/hana-logo-blanco.png";
import WhatsAppButton from "components/WhatsAppButton";

const SocialIcon = ({ children }) => (
  <div className="social-icon-wrapper">
    {children}
  </div>
);

const InstagramIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const socialLinks = [
  {
    href: "https://www.instagram.com/odpaulagonzalez/",
    username: "@odpaulagonzalez"
  },
  {
    href: "https://www.instagram.com/hana.odontologia/",
    username: "@hana.odontologia"
  }
];

export default function PageHeader() {
  return (
    <div className="page-header section">
      <Container style={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", paddingTop: "80px", paddingBottom: "40px" }}>
        <Row className="align-items-center flex-column-reverse flex-md-row w-100 justify-content-center no-negative-margin" style={{ marginLeft: 0, marginRight: 0 }}>
          <Col xs="12" md="6" className="d-flex flex-column align-items-center justify-content-center mb-5 mb-md-0" style={{ height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
              <h1 className="h1-seo text-center">
                <span>Clínica Odontológica</span>
              </h1>
              <p className="text-center hero-lead">
                Cuidamos tu sonrisa con tecnología, calidez y profesionalismo. Atención integral para toda la familia.
              </p>
              <div className="d-flex justify-content-center gap-4 gap-md-5 w-100" style={{ marginBottom: 32 }}>
                {socialLinks.map(link => (
                  <a
                    key={link.username}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex flex-column align-items-center"
                    style={{ textDecoration: "none", margin: 5 }}
                  >
                    <SocialIcon>
                      <InstagramIcon />
                    </SocialIcon>
                    <div className="social-handle">{link.username}</div>
                  </a>
                ))}
              </div>
            </div>
          </Col>
          <Col xs="12" md="6" className="d-flex flex-column align-items-center justify-content-center mb-4 mb-md-0" style={{ height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
              <img
                src={hanaLogo}
                alt="Logo Hana"
                className="img-fluid header-logo"
              />
              <WhatsAppButton showInitialButton={true} />
            </div>
          </Col>
        </Row>
      </Container>
      <style>{`
        @media (max-width: 991.98px) {
          .no-negative-margin {
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
        }
      `}</style>
    </div>
  );
}
